<template>
  <Card>
    <template #content>
      <ContentLoader
        :speed="2"
        viewBox="0 0 400 160"
        primaryColor="#ecebeb"
        secondaryColor="#d9d9d9"
      >
        <rect width="88" height="6" x="48" y="8" rx="3" ry="3"></rect>
        <rect width="52" height="6" x="48" y="26" rx="3" ry="3"></rect>
        <rect width="410" height="6" x="0" y="56" rx="3" ry="3"></rect>
        <rect width="380" height="6" x="0" y="72" rx="3" ry="3"></rect>
        <rect width="178" height="6" x="0" y="88" rx="3" ry="3"></rect>
        <circle cx="20" cy="20" r="20"></circle>
      </ContentLoader>
    </template>
  </Card>
</template>
<script setup lang="ts">
import { Card } from 'de-zurich-ui-library'
import { ContentLoader } from 'vue-content-loader'
</script>
